import React, { useEffect, useState } from 'react';
import { OrderTypes } from '../../common/enums/enums';
import { roundToTwoDecimal } from '../../helpers/numbers';
import VehicleDetails from '../VehicleDetails';
import VehicleDetailCard from './VehicleDetailCard';

export const VehicleCardView = ({
  apiLoading = false,
  photoCount,
  vehicle,
  history,
  isAddEstimateDisabled,
  onNewEstimateClick,
  handleStartDone,
  onAddTechnician,
  enableOrderTagActions,
  isVendor,
  enableStatusFilter,
}) => {
  const {
    orderId,
    orderType,
    amount: vehicleAmount = 0,
    dealershipName,
    vehicle: vehicleMetaData,
  } = vehicle;
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectValue, setSelectValue] = useState(1);
  const [relatedOrders, setRelatedOrders] = useState([]);

  const handleSelectChange = value => {
    setSelectValue(value);
  };

  const getRelatedOrdersOfType = (currentOrderType, allRelatedOrders) => {
    switch (currentOrderType) {
      case 1: {
        // filter relatedOrders of OrderType = ALL
        return {
          orders: allRelatedOrders,
          amount: roundToTwoDecimal.format(vehicleAmount),
        };
      }
      case 2: {
        // filter relatedOrders of OrderType = ESTIMATES
        const estimateOrders = allRelatedOrders?.filter(
          item => item?.orderType === OrderTypes.ESTIMATE
        );
        const estimateOrdersAmount =
          estimateOrders.reduce((sum, { amount }) => sum + amount, 0) || 0;
        return {
          orders: estimateOrders,
          amount: roundToTwoDecimal.format(estimateOrdersAmount),
        };
      }
      case 3: {
        // filter relatedOrders of OrderType = PACKAGES
        const packageOrders = allRelatedOrders?.filter(
          item => item?.orderType === OrderTypes.RECONDITIONING
        );
        const currentTotalAmount = vehicleAmount;
        const estimatesAmount =
          allRelatedOrders
            ?.filter(item => item?.orderType === OrderTypes.ESTIMATE)
            .reduce((sum, { amount }) => sum + amount, 0) || 0;
        const simpleOrderAmount =
          allRelatedOrders
            ?.filter(item => item?.orderType === OrderTypes.WORK_ORDER)
            .reduce((sum, { amount }) => sum + amount, 0) || 0;

        const packageOrdersAmount =
          currentTotalAmount - (estimatesAmount + simpleOrderAmount);

        return {
          orders: packageOrders,
          amount: roundToTwoDecimal.format(packageOrdersAmount),
        };
      }
      case 4: {
        // filter relatedOrders of OrderType = SERVICE WORK ORDER
        const serviceOrders = allRelatedOrders?.filter(
          item => item?.orderType === OrderTypes.SERVICE_ORDER
        );
        const serviceOrdersAmount =
          serviceOrders.reduce((sum, { amount }) => sum + amount, 0) || 0;
        return {
          orders: serviceOrders,
          amount: roundToTwoDecimal.format(serviceOrdersAmount),
        };
      }
      case 5: {
        // filter relatedOrders of OrderType = SIMPLE WORK ORDER
        const simpleOrders = allRelatedOrders?.filter(
          item => item?.orderType === OrderTypes.WORK_ORDER
        );
        const simpleOrdersAmount =
          simpleOrders.reduce((sum, { amount }) => sum + amount, 0) || 0;
        return {
          orders: simpleOrders,
          amount: roundToTwoDecimal.format(simpleOrdersAmount),
        };
      }
      default:
        return {
          amount: roundToTwoDecimal.format(vehicleAmount),
          orders: allRelatedOrders,
        };
    }
  };

  const setInitialEstimatesRelatedOrders = () => {
    const allRelatedOrders = vehicle.relatedOrders;
    const { orders, amount } = getRelatedOrdersOfType(
      selectValue,
      allRelatedOrders
    );
    setRelatedOrders(orders);
    setTotalAmount(amount);
  };

  useEffect(() => {
    setInitialEstimatesRelatedOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectValue]);

  useEffect(() => {
    setInitialEstimatesRelatedOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicle.relatedOrders]);

  const handleNewEstimateClick = () => {
    onNewEstimateClick(vehicle);
  };

  const showAsMiscOrders = () => {
    const firstDate = new Date(vehicle?.dateOrdered);
    const secondDate = new Date();

    const millisecondsDiff = secondDate.getTime() - firstDate.getTime();
    const daysDiff = Math.round(millisecondsDiff / (1000 * 60 * 60 * 24));

    return !!(
      vehicle?.orderType === 'reconditioning' &&
      vehicle?.step === 'Done' &&
      daysDiff < 60
    );
  };

  return (
    <div>
      <VehicleDetails
        variant="secondary"
        apiLoading={apiLoading}
        orderType={orderType}
        orderId={orderId}
        showPhotoCount={vehicleMetaData?.showPhotoCount}
        photoCount={photoCount}
        year={vehicleMetaData?.year}
        totalAmount={totalAmount}
        dealership={dealershipName}
        onChangeSelect={handleSelectChange}
        selectValue={selectValue}
        onClickAddEstimates={handleNewEstimateClick}
        isAddEstimateDisabled={isAddEstimateDisabled(vehicle)}
        showAsMiscOrder={showAsMiscOrders()}
      />
      <VehicleDetailCard
        relatedOrders={relatedOrders}
        history={history}
        enableAddEstimate={isAddEstimateDisabled(vehicle)}
        onNewEstimateClick={onNewEstimateClick}
        handleStartDone={handleStartDone}
        onAddTechnician={onAddTechnician}
        enableOrderTagActions={enableOrderTagActions}
        isVendor={isVendor}
        enableStatusFilter={enableStatusFilter}
      />
    </div>
  );
};
